<div class="container" #container>
  <ng-container #viewRef></ng-container>
  <ng-content></ng-content>
</div>
